import auth from "../../middlewares/auth";
export const settingsSubjectRoute = [
  {
    path: '/settings/subjects',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/subject/SubjectList'),
    name: 'settings_subject',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/subjects/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/subject/SubjectForm'),
    name: 'settings_subject_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/subjects/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/subject/SubjectForm'),
    name: 'settings_subject_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];